import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

//general
import PrivateRoute from './components/PrivateRoute';
import NodeAI from './sidebars/NodeAI';

const AIRoutes = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        path="/chat"
        element={
          <PrivateRoute
            permission={['ADMIN', 'MANAGER', 'STANDARD', 'OWNER', 'PERSONAL']}
          >
            <NodeAI />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AIRoutes;
